// extracted by mini-css-extract-plugin
export default {"base":"icon-module__base--cIK"};